import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-unsupported-viewer',
  templateUrl: './unsupported-viewer.component.html',
  styleUrls: ['./unsupported-viewer.component.scss']
})
export class UnsupportedViewerComponent {
  @Input() fileName: string | null = null;
  @Input() fileUrl: string | null = null;
  @Output() downloadRequested = new EventEmitter<string>();

  onDownload(): void {
    if (this.fileUrl) {
      this.downloadRequested.emit(this.fileUrl);
    }
  }
}
